if (!customElements.get("infinite-load")) {
  class InfiniteLoad extends HTMLElement {
    constructor() {
      super();
    }

    updateGrid(html) {
      const productGrid = html.getElementById(this.targetId);
      const currentGrid = document.getElementById(this.targetId);
      if(!currentGrid || !productGrid) return;

      currentGrid.insertAdjacentHTML('beforeend', productGrid.innerHTML);
    }

    updatePagination(html) {
      const pagination = html.querySelector('[js-pagination]');
      const currentPagination = document.querySelector('[js-pagination]');
      if(!currentPagination || !pagination) return;

      currentPagination.replaceWith(pagination);
    }

    loadNextPage() {
      fetch(this.url)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');

          this.updateGrid(html)
          this.updatePagination(html);
        })
        .catch((error) => console.log(error));
    }

    disconnectedCallback() {

    }

    connectedCallback() {
      this.targetId = this.getAttribute("js-target");
      this.url = this.getAttribute("js-url");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadNextPage();
            }
          });
        },
        {
          root: null,
          threshold: 0,
          rootMargin: "0px 0px -500px 0px",
        }
      );

      observer.observe(this);
    }
  }

  customElements.define("infinite-load", InfiniteLoad);
}
